import ToggleComponent from 'react-toggle';

import '../assets/toggle.css';

import TitleComponent from './Title';
import HeadingComponent from './Heading';
import SubtitleComponent from './Subtitle';
import InputComponent from './Input';
import InputFieldComponent from './InputField';
import BreadcrumbsComponent from './Breadcrumbs';
import ParentNavComponent from './ParentNav';
import BotTypeComponent from './BotType';
import NavHeaderComponent from './NavHeader';
import NavLinkComponent from './NavLink';
import TypeIconComponent from './TypeIcon';
import RowComponent from './Row';
import LayoutComponent from './Layout';
import JSONEditorComponent from './JSONEditor';
import PolicyEditorComponent from './PolicyEditor/policy-editor';
import AttributeEditorComponent from './AttributeEditor/index';
import PanelComponent from './Panel';
import DeleteComponent from './Delete';
import LoadingComponent from './Loading';
import SectionComponent from './Section';
import StepperComponent from './Stepper';
import AnalyticsItemComponent from './AnalyticsItem';
import AnalyticsOverflowItemComponent from './AnalyticsOverflowItem';
import LinkComponent from './Link';
import NavigationLinkComponent from './NavigationLink';
import FeatureGateComponent from './feature-gate';
import ProductLogoComponent from './ProductLogo';
import AutomationListComponent from './AutomationList';
import AutomationItemComponent from './AutomationItem';
import DeleteBucketComponent from './DeleteBucket';
import SkillsSelectorComponent from './SkillsSelector';
import RecommendedActionsKBDocComponent from './RecommendedActionsKBDoc';
import DropDownComponent from './DropDown';
import DividerComponent from './Divider';
import InfoComponent from './Info';
import SelectComponent from './Select';
import TypeaheadComponent from './Typeahead';
import { PolicySearch, NextActionSummaryCard, PolicyExecutionHistory } from './debugger';
import HorizontalRuleComponent from './HorizontalRule';
import SearchFilterComponent from './SearchFilter';
import ScrollBoxComponent from './ScrollBox';
import TooltipComponent from './Tooltip';
import PaginationComponent from './Pagination';
import InputAdornmentComponent from './InputAdornment';
import CollapsibleDrawerArrowComponent from './collapsible-drawer-arrow';
import ResultsEmptyComponent from './results-empty';
import CopyableTextComponent from './copyable-text';
import { PolicyReorderComponent, PoliciesCcsV1Component, PoliciesCcsV2Component } from './policy';
import CheckboxComponent from './Checkbox';
import { DeveloperKeysV1, DeveloperKeysV2 } from './settings';
import NavigateGuardComponent from './navigate-guard';
import NewTagComponent from './new-tag';
import AppWrapperComponent from './app-wrapper';
import MultilineTextWithEllipsisComponent from './multiline-text-with-ellipsis';
import ElidableTextComponent from './elidable-text';
import StandardLoadingComponent from './standard-loading';
import SkeletonLogsComponent from './skeleton-logs';

export const Title = TitleComponent;
export const Heading = HeadingComponent;
export const Subtitle = SubtitleComponent;
export const Input = InputComponent;
export const InputField = InputFieldComponent;
export const Breadcrumbs = BreadcrumbsComponent;
export const ParentNav = ParentNavComponent;
export const BotType = BotTypeComponent;
export const NavHeader = NavHeaderComponent;
export const NavLink = NavLinkComponent;
export const Toggle = ToggleComponent;
export const TypeIcon = TypeIconComponent;
export const Row = RowComponent;
export const Layout = LayoutComponent;
export const JSONEditor = JSONEditorComponent;
export const PolicyEditor = PolicyEditorComponent;
export const AttributeEditor = AttributeEditorComponent;
export const Panel = PanelComponent;
export const Delete = DeleteComponent;
export const Loading = LoadingComponent;
export const Section = SectionComponent;
export const Stepper = StepperComponent;
export const AnalyticsItem = AnalyticsItemComponent;
export const AnalyticsOverflowItem = AnalyticsOverflowItemComponent;
export const Link = LinkComponent;
export const NavigationLink = NavigationLinkComponent;
export const FeatureGate = FeatureGateComponent;
export const ProductLogo = ProductLogoComponent;
export const AutomationList = AutomationListComponent;
export const AutomationItem = AutomationItemComponent;
export const DeleteBucket = DeleteBucketComponent;
export const SkillsSelector = SkillsSelectorComponent;
export const RecommendedActionsKBDoc = RecommendedActionsKBDocComponent;
export const Dropdown = DropDownComponent;
export const Divider = DividerComponent;
export const Info = InfoComponent;
export const Select = SelectComponent;
export const Typeahead = TypeaheadComponent;
export { PolicySearch, NextActionSummaryCard, PolicyExecutionHistory };
export const HorizontalRule = HorizontalRuleComponent;
export const SearchFilter = SearchFilterComponent;
export const ScrollBox = ScrollBoxComponent;
export const Tooltip = TooltipComponent;
export const Pagination = PaginationComponent;
export const InputAdornment = InputAdornmentComponent;
export { DeveloperKeysV1, DeveloperKeysV2 };
export {
  Card, InfoCard, CardBody,
  CardHeader,
} from './card';
export const CollapsibleDrawerArrow = CollapsibleDrawerArrowComponent;
export const ResultsEmpty = ResultsEmptyComponent;
export const CopyableText = CopyableTextComponent;
export * from './modal';
export const PolicyReorder = PolicyReorderComponent;
export const PoliciesCcsV2 = PoliciesCcsV2Component;
export const PoliciesCcsV1 = PoliciesCcsV1Component;
export * from './v2';
export const Checkbox = CheckboxComponent;
export const NavigateGuard = NavigateGuardComponent;
export const NewTag = NewTagComponent;
export const AppWrapper = AppWrapperComponent;
export const MultilineTextWithEllipsis = MultilineTextWithEllipsisComponent;
export const ElidableText = ElidableTextComponent;
export const StandardLoading = StandardLoadingComponent;
export const SkeletonLogs = SkeletonLogsComponent;
